// extracted by mini-css-extract-plugin
export default {"deleteUser":"Permitters_deleteUser__uv7kJ","addPortalButton":"Permitters_addPortalButton__4YT1k"};